export const handleClickViaKeyboard = (callback) => {
  return (event) => {
    if (event.key === "Enter" || event.key === " ") {
      // Enter or Space
      event.preventDefault()
      callback(event)
    }
  }
}
